import searchComponent from './search.component';

const searchModule = angular
  .module('searchModule', [])
  .component('search', searchComponent);

export default searchModule;


/** WEBPACK FOOTER **
 ** ./frontend/components/active/search/search.js
 **/